export type ErrorResponseBody = {
  error?: unknown;
  errorCode?: unknown;
};

export const readErrorBody = async (
  response: Pick<Response, 'json'>,
): Promise<ErrorResponseBody> => {
  try {
    const body: unknown = await response.json();
    return body !== null && typeof body === 'object'
      ? (body as ErrorResponseBody)
      : {};
  } catch {
    return {};
  }
};
